<div class="checkboxes-modal-empty">
  <div mat-dialog-title>
    <h2>{{"servers.Assign server" | translate}}</h2>
    <button mat-icon-button class="close" matDialogClose>
      <mat-icon class="pop-close">close</mat-icon>
    </button>
  </div>

  <div *ngIf='dataLoading' class="dataLoading">
    <mat-spinner class="m-auto" diameter="50"></mat-spinner>
  </div>
  <ng-container *ngIf='!dataLoading'>
    <div class="modal-subhead">
      <div class="row align-items-center">
        <div class="col-6">
          <div class="d-flex align-items-center">
            <div class="font-18 mr-3">
              <span class="grey-color">{{ 'content4.Table' | translate }}: </span>
              <span class="fontMedium">{{data.reservation.tableName}}</span>
            </div>
          </div>
        </div>
        <div class="col-6 d-block m-auto">
            <div class="form-group">
              <div class="input-group search-control">
                <div class="input-group-prepend">
                  <button class="input-group-text" type="button">
                    <img src="./assets/images/icons/search.svg" alt="">
                  </button>
                </div>
                <input type="text" maxlength="20"
                  class="form-control font-14"
                  [(ngModel)]="searchText"
                  [placeholder]="'servers.Search by server name' | translate">
              </div>
            </div>
        </div>
      </div>
    </div>
    <mat-dialog-content class="pt-1 checkboxes-modal">
      <div class="mat-dialog-body">

        <mat-radio-group [(ngModel)]="userId">
            <ng-container *ngFor="let item of serversList; index as index">
            <div [hidden]="searchText && hideOption(item)">
                <mat-radio-button class="p-2 d-block"
                [value]="item.id"
                [class.border-0]="index == serversList.length-1">
                <div class="name-with-image ml-3">
                    <div class="image-circle rounded-circle">
                    <img [src]="item.profilePic" *ngIf="item.profilePic" (error)="item.profilePic = ''" alt="">
                    <span *ngIf="!item.profilePic">{{item.name | shortName}}</span>
                    </div>
                    <div class="name">
                    <h5 class="font-16">{{item.name}}</h5>
                    </div>
                    <div class="ml-2 grey-color font-14 ">
                    ({{item.reservationCount}} {{'servers.reservations assigned' | translate}})
                    </div>
                </div>
                </mat-radio-button>
            </div>
            </ng-container>
        </mat-radio-group>

        <p class="has-error" *ngIf="!userId && isSubmitted">{{'servers.Please sealect server.' | translate}}</p>

        <div class="data-empty" [hidden]="!isAllHidden()">
          <p>{{"general.No Data Found" | translate}}</p>
        </div>

      </div>
    </mat-dialog-content>

    <mat-dialog-actions>
      <button mat-button class="btn-grey" matDialogClose>{{"forms.Cancel" | translate}}</button>


      <button (click)="saveRecord()" mat-raised-button color="primary"
        [disabled]="loading"
        [class.loading]="loading">
        {{"forms.Submit" | translate}}
      </button>

    </mat-dialog-actions>

    <ng-template #dataEmpty>
      <empty-state [title]='"general.No Data Found" | translate'></empty-state>
    </ng-template>
  </ng-container>
</div>
